import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { GasTableComponent } from '../gas-table/gas-table.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'gas-table-header-checkbox',
  templateUrl: `./gas-table-header-checkbox.component.html`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasTableHeaderCheckboxComponent implements OnInit {

  @Input()
  public disableRowSelectionFilter: ((rowData: Record<string, unknown>) => boolean) | undefined;

  public get isChecked(): boolean {
    return this.isCheckedSubject$.value;
  }

  public set isChecked(value: boolean) {
    this.isCheckedSubject$.next(value);
  }

  public get isIndeterminate(): boolean {
    return this.isIndeterminateSubject$.value;
  }

  public set isIndeterminate(value: boolean) {
    this.isIndeterminateSubject$.next(value);
  }

  public isChecked$: Observable<boolean>;

  public isIndeterminate$: Observable<boolean>;

  private isCheckedSubject$ = new BehaviorSubject<boolean>(false);

  private isIndeterminateSubject$ = new BehaviorSubject<boolean>(false);

  constructor(
    private gasTableComponent: GasTableComponent,
  ) {
    this.isChecked$ = this.isCheckedSubject$.asObservable();
    this.isIndeterminate$ = this.isIndeterminateSubject$.asObservable();

    this.gasTableComponent.tableService.selectionSource$
      .pipe(
        untilDestroyed(this),
      )
      .subscribe(() => {
        this.updateCheckedState();
      });
  }

  public ngOnInit(): void {
    this.updateCheckedState();
  }

  public onClick(): void {
    if (this.gasTableComponent.data?.length > 0) {
      this.gasTableComponent.toggleRowsWithCheckbox(!this.isChecked);
    }
  }

  public updateCheckedState(): void {
    if (this.gasTableComponent.data) {
      const tableValue = this.gasTableComponent.data.filter(rowData => this.disableRowSelectionFilter
        ? !this.disableRowSelectionFilter(rowData)
        : true,
      );
      const selectedValue = this.gasTableComponent.tableSelectedRows;

      if (tableValue.length && selectedValue) {
        this.isChecked = selectedValue.length === tableValue.length;
        this.isIndeterminate = selectedValue.length > 0 && selectedValue.length < tableValue.length;
      }
    }
  }

}
